<template>
    <!-- Add Diagnosis -->
    <div class="card" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }" v-if="diagnosisCard">
        <div class="card-content">
            <div class="row">
                <form class="col s12">
                    <div class="row">
                        <div class="col s12">
                            <span class="card-title">{{
                                resetDiagnosis ? "Edit Diagnosis" : "Add Diagnosis"
                                }}</span>
                        </div>

                        <div class="input-field col s12">
                            <input v-model="diagnosis" id="diagnosis" type="text" />
                            <label class="active" for="diagnosis">Diagnosis</label>
                        </div>

                        <div class="input-field col s12">
                            <a class="waves-effect waves-light btn red lighten-2 col s12 m2 left"
                                @click.prevent="handleRefresh('diagnosis')">
                                <i class="medium material-icons left">clear</i>Cancel
                            </a>
      
                            <!-- Breaker -->
                            <span class="co1 m7"></span>

                            <button class="waves-effect waves-light btn-large col s12 m3 right" :class="{ 'green': diagnosis }"
                                @click.prevent="handleDiagnosis">
                                <i class="medium material-icons left">{{
                                    resetDiagnosis ? "sync" : "chevron_right"
                                    }}</i>{{ resetDiagnosis ? "Confirm Edit" : "Next" }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Add Claims -->
    <div class="card claim-collection-add-card provider-claim-add-card" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }" v-if="claimsCard">
        <div class="card-content">
            <div class="row">
                <form class="col s12">
                    <div class="row">
                        <div class="col s12" v-if="!editId">
                            <span class="card-title">Select Item
                                <span class="secondary-content tariff-card-actions">
                                    <button type="button" class="btn-flat tariff-card-icon-action tariff-preview-top-action"
                                        title="View tariff items" @click.prevent="handleTariffPreview" v-if="hasTariffs && !isTariffLoading">
                                        <i class="material-icons">visibility</i>
                                    </button>
                                    <i class="material-icons tariff-mini-spin grey-text" v-if="isTariffLoading">autorenew</i>
                                    <button type="button" class="btn-flat tariff-card-icon-action" title="Refresh tariff items"
                                        @click.prevent="handleTariffReload" v-else>
                                        <i class="material-icons">refresh</i>
                                    </button>
                                </span>
                            </span>
                            <!-- <span>
                                <i class="material-icons clickable"
                                    :class="{ 'orange-text': showAuth, 'teal-text': !showAuth, }"
                                    :title="`${showAuth ? 'Remove Authorization' : 'Add Authorization Code'}`"
                                    @click.prevent="handleShowAuth">{{ showAuth ? 'cancel' : 'arrow_drop_down_circle'
                                    }}</i>
                            </span> -->
                        </div>
                        <div class="col s12" v-if="tariffMessage && !isTariffLoading">
                            <p class="tariff-card-message">{{ tariffMessage }}</p>
                        </div>
                        <div class="input-field col s12 m6">
                            <TariffSearch inputId="filterClaim" :data="filterData" :startAgain="resetClaim"
                                :startEdit="editClaim" :disabled="isSubmitting || isTariffLoading || !hasTariffs" @selected="handlePick"
                                @searching="handleSearch" @clear="handleClear" />
                        </div>
                        <!-- <div class="input-field col s2">
              <input v-model="selectedPrice" id="standard" type="number" disabled />
              <label class="active" for="standard">Rate</label>
            </div> -->
                        <div class="input-field col s6 m3">
                            <input v-model="qty" @input="handlePricing" id="qty" type="number"
                                :disabled="isSubmitting" />
                            <label class="active" for="qty">Quantity</label>
                        </div>
                        <div class="input-field col s6 m3">
                            <input v-model="amt" id="amt" type="number" readonly :disabled="isSubmitting" />
                            <label class="active" for="amt">Amount Charged</label>
                        </div>

                        <div class="input-field col s12" v-if="showAuth">
                            <input v-model="auth" id="auth" type="text" :disabled="isSubmitting" />
                            <label class="active" for="auth">Add Authorization Code</label>
                        </div>

                        <div class="input-field col s12">
                            <a class="waves-effect waves-light btn red lighten-2 col s12 m2 left" :class="{ 'disabled': isSubmitting }"
                                @click.prevent="handleRefresh('claim')">
                                <i class="medium material-icons left">clear</i>Close
                            </a>

                            <a v-if="(type == 'claim') && (editId == null) && claimsList.length"
                                class="waves-effect waves-light btn-large blue col s12 m2 right" :class="{
                                    'disabled': isSubmitting, blue: !(selectedItem && qty && amt) && claimsList.length,
                                }" @click="handleNext('review')"><i class="medium material-icons left">chevron_right</i>Next</a>

                            <!-- Breaker -->
                            <span class="co1 m5"></span>

                            <button class="waves-effect waves-light black btn-large col s12 m3 right"
                                :class="{ 'disabled': isSubmitting, pulse: addPulse }" @click.prevent="handleClaims">
                                <i class="medium material-icons left">{{
                                    editId ? "sync" : "add"
                                    }}</i>{{ editId ? "Edit Item" : "Add Item" }}
                            </button>
                        </div>
                    </div>


                </form>

            </div>

        </div>

    </div>

    <Teleport to="body">
        <div class="tariff-preview-overlay" @click.self="handleTariffPreviewClose" v-if="isTariffPreviewOpen">
            <section :id="tariffModalId" class="tariff-preview-modal" role="dialog" aria-modal="true" aria-label="Tariff items">
                <button type="button" class="tariff-preview-close" title="Close" @click.prevent="handleTariffPreviewClose">
                    <i class="material-icons">close</i>
                </button>
                <div class="tariff-preview-content">
                    <h5>Tariff Items</h5>
                    <div class="input-field tariff-preview-search">
                        <input v-model="tariffPreviewSearch" :id="`${tariffModalId}-search`" type="search" />
                        <label class="active" :for="`${tariffModalId}-search`">Search tariff item</label>
                    </div>
                    <ul class="collection tariff-preview-list" v-if="filteredTariffPreview.length">
                        <li class="collection-item" v-for="tariff in filteredTariffPreview" :key="`${tariff.item}-${tariff.price}`">
                            <span>{{ tariff.item }}</span>
                            <b class="secondary-content">&#8358;{{ formatMoney(tariff.price) }}</b>
                        </li>
                    </ul>
                    <p class="grey-text" v-else>No tariff item matches your search.</p>
                </div>
                <div class="tariff-preview-footer">
                    <button type="button" class="btn-flat waves-effect waves-teal" @click.prevent="handleTariffPreviewClose">Close</button>
                </div>
            </section>
        </div>
    </Teleport>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";
import getItems from "@/composables/getItems";
import TariffSearch from "@/components/search/TariffSearch.vue";
import { capitalizeFirstLetter } from "@/composables/fxLibrary/coreFx";
import { urlFormat } from "@/composables/tariff/urlFormat";
import { getCache, addCache, removeCache } from "@/composables/cache/cache";
import { addClaimSave, updateSavedClaim, deleteSavedClaim } from "@/composables/serverCaller/serverCaller";

export default {
    name: "AddManualClaimComponent",
    emits: ["update", "clear", "claims-updated"],
    props: ["turl", "type", "next", "editDiagnosis", "claimItem", "reload"],
    components: { TariffSearch },
    setup(props, context) {
        const isSubmitting = ref(false);
        const responseDefault = ref([]);
        const responseSearch = ref([]);
        const error = ref(false);
        const addPulse = ref(false);
        const submitPulse = ref(false);
        const diagnosis = ref(null);
        const diagnosisList = ref([]);
        const hasDiagnosis = computed(() => diagnosisList.value.some((entry) => String(entry || "").trim()));
        const cache = ref({});
        const diagnosisCard = ref(true);
        const selectedItem = ref(null);
        const selectedPrice = ref(null);
        const resetDiagnosis = ref(false);
        const editClaim = ref(null);
        const editId = ref(null);
        const deleteId = ref(null);
        const resetClaim = ref(false);
        const claimsCard = ref(false);
        const claimsDisplayCard = ref(false);
        const claimsSubmitCard = ref(false);
        const claimsList = ref([]);
        const claim = ref(null);
        const qty = ref(null);
        const amt = ref(null);
        const auth = ref(null);
        const showAuth = ref(false);
        const tariffUrl = ref(null);
        const isTariffLoading = ref(false);
        const tariffError = ref(null);
        const tariffLoaded = ref(false);
        const tariffPreviewSearch = ref("");
        const isTariffPreviewOpen = ref(false);
        const tariffModalId = `providerClaimTariffPreview-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const hasTariffs = computed(() => responseDefault.value.length > 0);
        const tariffMessage = computed(() => {
            if (tariffError.value) {
                return tariffError.value;
            }
            if (tariffLoaded.value && !hasTariffs.value) {
                return "No tariff item is available for this scheme and provider.";
            }
            return null;
        });
        const filteredTariffPreview = computed(() => {
            const term = tariffPreviewSearch.value?.toLowerCase();
            if (!term) {
                return responseDefault.value;
            }
            return responseDefault.value.filter(x => x.item?.toLowerCase().includes(term));
        });

        const emitClaimsUpdated = (changed = false) => {
            context.emit("claims-updated", {
                claims: claimsList.value,
                changed,
            });
        };


        // reload
        onMounted(() => {
            // check reload
            if (props.reload) {
                // re-set
                claimsList.value = props.reload.claims;
                if (props.reload.diagnosis) {
                    diagnosisList.value.push(props.reload.diagnosis);
                }
                if (props.reload.claims.length) {
                    // carry on
                    handleNext('review');
                } else {
                    if (diagnosisList.value?.length) {
                        // carry on
                        handleNext('moreClaims');
                    }
                }

                emitClaimsUpdated();
            }
        });

        // data tariff
        const filterData = computed(() => {
            // start
            let val = {};

            let valPlus;

            if (responseSearch.value) {
                valPlus = responseSearch.value.reduce((newArr, x) => {
                    newArr[x.item] = null;
                    return newArr;
                }, {});
                val = { ...val, ...valPlus };
            }

            // return final
            return val;
        });

        // search function
        const getTariffFromApi = async (table, force = false) => {
            if (!table) {
                tariffError.value = "Unable to load tariff items for this scheme and provider.";
                tariffLoaded.value = true;
                return;
            }
            tariffUrl.value = table;
            tariffError.value = null;
            // get item from store (cache)
            let cacheTariff = getCache(table);
            // get from api
            if (cacheTariff?.length && !force) {
                responseDefault.value = cacheTariff;
                tariffLoaded.value = true;
            } else {
                isTariffLoading.value = true;
                const { res, err } = await getItems(table);
                if (res.value) {
                    // search
                    responseDefault.value = res.value.data || [];
                    // add cache
                    addCache(table, responseDefault.value);
                } else {
                    tariffError.value = err.value || "Unable to load tariff items for this scheme and provider.";
                }
                tariffLoaded.value = true;
                isTariffLoading.value = false;
            }
        };

        // starter (set loading spin)
        onMounted(() => {
            // tariff url
            let url = urlFormat(props.turl);
            // get items from function
            getTariffFromApi(url);
        });

        const handleTariffReload = () => {
            if (!tariffUrl.value) {
                return;
            }
            removeCache(tariffUrl.value);
            getTariffFromApi(tariffUrl.value, true);
        };

        const handleTariffPreview = () => {
            tariffPreviewSearch.value = "";
            isTariffPreviewOpen.value = true;
        };

        const handleTariffPreviewClose = () => {
            isTariffPreviewOpen.value = false;
        };

        const formatMoney = (val) => {
            return Number(val || 0)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };

        // add up
        const totalSent = (claims) => {
            let total = 0;
            claims.forEach((x) => {
                total = Number(total) + Number(x.amt);
            });
            return total
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };

        // showAuth
        const handleShowAuth = () => {
            if (showAuth.value) {
                // clear
                showAuth.value = false;
                auth.value = null;
            } else {
                // open
                showAuth.value = true;
            }
        }

        // // handle pricing
        // const handlePricing = (val) => {
        //   if (val == 'qty') {
        //     qty.value = null;
        //     amt.value = 0;
        //   }

        //   if (val == 'amt') {
        //     amt.value = null;
        //   }
        // }

        // watch qty & price
        const handlePricing = () => {
            amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(2);
        };

        // refresh field
        const handleRefresh = (type) => {
            if (type === "diagnosis") {
                resetDiagnosis.value = false;
                // clear entry
                diagnosis.value = null;
                // clear pulse (if needed)
                addPulse.value = false;
                // clear error (if needed)
                error.value = false;
                // clear resetDiagnosis in parent (if needed)
                context.emit("clear", {
                    id: "resetDiagnosis",
                    value: false,
                });
            } else if (type === "claim") {
                // clear entry
                claimInputClear();
            }
            // redirect
            if (claimsList.value.length) {
                handleNext("review");
            } else {
                handleNext("claims");
            }
        };

        // null diagnosis crew
        const handleReviewDiagnosis = () => {
            // clear diagnosis
            diagnosisCard.value = true;
            // true claims
            claimsCard.value = false;
            claimsDisplayCard.value = false;
            claimsSubmitCard.value = false;
            // clear everything about diagnosis
            diagnosis.value = diagnosisList.value.join(", ");
            resetDiagnosis.value = true;

            // clear entry (insurance)
            claimInputClear();

            // clear edit (if needed)
            editId.value = null;
            // clear pulse (if needed)
            addPulse.value = false;
            // clear error (if needed)
            error.value = false;
        };

        // delete claim
        const handleDelete = async (claim) => {
            // start 
            deleteId.value = claim.id;

            // set newVal
            let newVal = {
                status: "d",
                stores: claim?.encounter_id, // applies to saved
                encounter_id: 0, // applies to saved
            };

            // if saved
            if (claim?.created_at) {
                newVal = await deleteSavedClaim(claim.id, newVal); // newVal is null if it fails
            }

            if (newVal !== null) {
                // delete
                const index = claimsList.value.findIndex(
                    (x) => x.id === claim.id
                );
                if (index !== -1) {
                    // found record
                    claimsList.value[index] = {
                        ...claimsList.value[index],
                        ...newVal // update delete
                    };
                    // filter
                    claimsList.value = claimsList.value.filter(x => x.id !== claim?.id);
                    emitClaimsUpdated(true);
                }

                // end
                deleteId.value = null;

                // check if all has been removed
                if (!claimsList.value.length) {
                    handleNext("claims");
                }

            }
        };

        // edit claim
        const handleEdit = (claim) => {
            if (editId.value != claim.id) {

                // for child component
                editClaim.value = claim.claim;

                // for main
                editId.value = claim.id;
                selectedItem.value = claim.claim;
                selectedPrice.value = claim.standard;
                qty.value = claim.qty;
                amt.value = claim.amt;

                // auth checker
                if (claim?.authorization_code) {
                    auth.value = claim.authorization_code;
                    showAuth.value = true;
                } else {
                    auth.value = null;
                    showAuth.value = false;
                }

                // clear submit outlook
                handleNext("moreClaims");
            } else {
                // same item was clicked twice
                // clear all
                claimInputClear();
                handleNext("review");
            }
        };

        // null diagnosis input field
        const handleClearInput = (field) => {
            if (field === "diagnosis") {
                resetDiagnosis.value = false;
                // clear diagnosis
                diagnosis.value = null;
                // clear pulse (if needed)
                addPulse.value = false;
                // clear error (if needed)
                error.value = false;
            }
        };

        // handle diagnosis
        const handleDiagnosis = () => {
            if (diagnosis.value?.trim() && !isSubmitting.value) {
                // format for saving
                const { fx } = capitalizeFirstLetter(diagnosis.value.trim());

                // set
                cache.value.diagnosis = diagnosisList.value.join(", ");

                // override diagnosis array
                if (resetDiagnosis.value) {
                    diagnosisList.value = [];
                    diagnosisList.value.push(fx.value);
                } else {
                    diagnosisList.value.push(fx.value);
                }

                // null result
                diagnosis.value = null;
                // reset error (if required)
                error.value = false;
                // clear pulse (if required)
                addPulse.value = false;

                // clear entry (insurance)
                claimInputClear();

                // move straight to review (if edit)
                if (resetDiagnosis.value) {
                    resetDiagnosis.value = false;
                    // emit clear
                    context.emit("clear", {
                        id: "resetDiagnosis",
                        value: false,
                    });
                }

                // Auto-Next
                if (claimsList.value.length) {
                    handleNext("review");
                } else {
                    handleNext("claims");
                }

            } else {
                error.value = true;
            }
        };

        // clear inputs
        const claimInputClear = () => {
            // clear all
            selectedItem.value = null;
            selectedPrice.value = null;
            resetClaim.value = true; // will clear claims input
            qty.value = null;
            amt.value = null;
            auth.value = null;
            showAuth.value = false;
            responseSearch.value = [];

            // clear edit (if needed)
            editId.value = null;
            // clear editId in parent (if needed)
            context.emit("clear", {
                id: "editId",
                value: null,
            });
            // clear pulse (if needed)
            addPulse.value = false;
            // clear error (if needed)
            error.value = false;
        };

        // load claims
        const handleClaims = async () => {
            // start action
            if (selectedItem.value && qty.value && amt.value) {
                // start
                let newVal = null;

                // format for saving
                const { fx } = capitalizeFirstLetter(selectedItem.value);

                // for review activation
                let editIdVal = null;
                let claimsChanged = false;

                // process
                if (editId.value) {
                    editIdVal = editId.value; // for review activation
                    // edit
                    const index = claimsList.value.findIndex(
                        (x) => x.id === editId.value
                    );

                    if (index !== -1) {
                        // found

                        // set value
                        newVal = {
                            claim: fx.value,
                            qty: qty.value,
                            amt: Number(amt.value).toFixed(2),
                            authorization_code: auth.value,
                        }

                        // if saved
                        if (claimsList.value[index]?.created_at) {
                            isSubmitting.value = true;
                            newVal = await updateSavedClaim(editId.value, newVal); // newVal is null if it fails
                            if (newVal === null) { error.value = true } //output
                            isSubmitting.value = false;
                        }

                        if (newVal !== null) {

                            claimsList.value[index] = {
                                ...claimsList.value[index],
                                ...newVal,
                            };
                            claimsChanged = true;

                        }

                    }
                } else {

                    // set value
                    newVal = {
                        id: Date.now(),
                        claim: fx.value,
                        qty: qty.value,
                        amt: Number(amt.value).toFixed(2),
                        standard: Number(selectedPrice.value).toFixed(2),
                        authorization_code: auth.value,
                        status: "a", //active
                    }

                    // if saved (saved will atleast have one claim saved)
                    if (claimsList.value.length && claimsList.value[0]?.created_at) {
                        isSubmitting.value = true;
                        newVal = await addClaimSave(claimsList.value[0].encounter_id, newVal); // newVal is null if it fails
                        if (newVal === null) { error.value = true } //output
                        isSubmitting.value = false;
                    }

                    if (newVal !== null) {

                        // add to claims array
                        claimsList.value.push({
                            ...newVal,
                        });
                        claimsChanged = true;

                    }
                }

                if (newVal !== null) {
                    if (claimsChanged) {
                        emitClaimsUpdated(true);
                    }

                    // clear entry
                    claimInputClear();

                    /*
                    Auth parents and Edit requests
                    Others will skip this
                    */
                    if ((props.type == "auth") || (editIdVal)) {
                        handleNext("review");
                    }


                    // reset error (if required)
                    error.value = false;
                }
            } else {
                error.value = true;
            }

            // open display
            if (claimsList.value.length) {
                claimsDisplayCard.value = true;
            }
        };

        // handle next
        const handleNext = (next) => {
            if (next === "claims") {
                if (!diagnosis.value && hasDiagnosis.value) {
                    // clear diagnosis
                    diagnosisCard.value = !hasDiagnosis.value;
                    // true claims
                    claimsCard.value = true;
                    claimsDisplayCard.value = false;
                    claimsSubmitCard.value = false;
                    // clear everything about diagnosis
                    diagnosis.value = null;

                    // reset error (if required)
                    error.value = false;
                } else {
                    // set error
                    error.value = true;
                    // set pulse
                    if (diagnosis.value) {
                        addPulse.value = true;
                    }
                }
            } else if (next === "review") {
                if (
                    !(selectedItem.value && qty.value && amt.value) &&
                    claimsList.value.length
                ) {
                    // clear diagnosis addition card
                    diagnosisCard.value = !hasDiagnosis.value;
                    // true claims
                    claimsCard.value = false;
                    claimsDisplayCard.value = true;
                    claimsSubmitCard.value = true;
                    // clear everything about diagnosis (in case it's still active)
                    diagnosis.value = null;

                    // reset error (if required)
                    error.value = false;

                    // delay submit pulse
                    setTimeout(() => {
                        submitPulse.value = true;
                    }, 5000);
                } else {
                    // set error
                    error.value = true;
                    // set pulse
                    if (selectedItem.value && qty.value && amt.value) {
                        addPulse.value = true;
                    }
                }
            } else if (next === "moreClaims") {
                // clear diagnosis addition card
                diagnosisCard.value = !hasDiagnosis.value;
                // true claims
                claimsCard.value = true;
                claimsDisplayCard.value = false;
                claimsSubmitCard.value = false;
                // clear everything about diagnosis
                diagnosis.value = null;

                // reset error (if required)
                error.value = false;
            }

            // open display
            if (claimsList.value.length) {
                claimsDisplayCard.value = true;
            }
        };

        // filter components
        const handleSearch = (val) => {
            if (val.item) {
                // sort new search
                responseSearch.value = responseDefault.value.filter((x) =>
                    x.item.toLowerCase().includes(val.item.toLowerCase())
                );
            } else {
                // empty search array
                responseSearch.value = [];

                // clear entry
                claimInputClear();
            }
        };

        // null reset
        const handleClear = (val) => {
            resetClaim.value = val.item;
            editClaim.value = val.item;
        };

        // get option
        const handlePick = (val) => {
            //set
            selectedItem.value = val.item;

            //set
            if (selectedItem.value) {
                // get the price out
                responseSearch.value.forEach((x) => {
                    if (x.item === selectedItem.value) {
                        // found
                        selectedPrice.value = x.price;
                    }
                });

                // set quantity & amount
                qty.value = 1;
                amt.value = (Number(qty.value) * Number(selectedPrice.value)).toFixed(
                    2
                );

            } else {
                // if null (very unlikely)
                // clear entry
                claimInputClear();
            }
        };

        // Explicit sources keep synchronous parent handlers out of dependency tracking.
        watch(
            [claimsDisplayCard, claimsSubmitCard, diagnosisList, submitPulse, deleteId, cache],
            () => {
                if (diagnosisList.value.length) {
                    context.emit("update", {
                        claimsDisplayCard: claimsDisplayCard.value,
                        claimsSubmitCard: claimsSubmitCard.value,
                        diagnosisList: diagnosisList.value,
                        submitPulse: submitPulse.value,
                        deleteId: deleteId.value,
                        cache: cache.value,
                    });
                }
            },
            { deep: true }
        );

        // handle delete/edit requests
        const reviewClaim = (val) => {
            if (val) {
                if (val.action == "edit") {
                    handleEdit(val.claim);
                } else if (val.action == "delete") {
                    handleDelete(val.claim);
                }
            }
        };

        // Watch only command props; reload may contain a large claims collection.
        watch(() => props.claimItem, (claimItem) => {
            if (claimItem) {
                reviewClaim(claimItem);
                context.emit("clear", {
                    id: "claim",
                    value: null,
                });
            }
        });

        // watch more changes
        watch(() => props.editDiagnosis, (editDiagnosis) => {
            if (editDiagnosis) {
                handleReviewDiagnosis();
            }
        });

        // watch even more changes
        watch(() => props.next, (next) => {
            if (next) {
                handleNext(next);
                context.emit("clear", {
                    id: "next",
                    value: null,
                });
            }
        });

        return {
            handleShowAuth,
            handlePricing,
            handleClearInput,
            handleDiagnosis,
            handleDelete,
            handleEdit,
            handleClaims,
            handleTariffReload,
            handleTariffPreview,
            handleTariffPreviewClose,
            handleReviewDiagnosis,
            handleNext,
            handleSearch,
            handleClear,
            handlePick,
            handleRefresh,
            isSubmitting,
            totalSent,
            selectedItem,
            selectedPrice,
            resetDiagnosis,
            editClaim,
            editId,
            deleteId,
            resetClaim,
            filterData,
            filteredTariffPreview,
            formatMoney,
            hasTariffs,
            isTariffLoading,
            isTariffPreviewOpen,
            tariffMessage,
            tariffModalId,
            tariffPreviewSearch,
            error,
            addPulse,
            diagnosis,
            diagnosisList,
            diagnosisCard,
            claimsDisplayCard,
            claimsList,
            claimsCard,
            claim,
            qty,
            amt,
            auth,
            showAuth,
        };
    },
};
</script>

<style>
.claim-collection-add-card,
.claim-collection-add-card .card-content,
.claim-collection-add-card form,
.claim-collection-add-card .row,
.claim-collection-add-card .input-field {
    overflow: visible;
}

.claim-collection-add-card {
    position: relative;
    z-index: 20;
}

.claim-collection-add-card .autocomplete-content.dropdown-content {
    max-height: 320px;
    overflow-y: auto;
    z-index: 1200;
}

.provider-claim-add-card .tariff-card-actions {
    align-items: center;
    display: inline-flex;
    gap: 3px;
    margin-top: -2px;
}

.provider-claim-add-card .tariff-card-actions .tariff-card-icon-action.btn-flat {
    align-items: center;
    background-color: #ffffff !important;
    border: 1px solid rgba(84, 110, 122, 0.22);
    border-radius: 18px;
    box-shadow: 0 5px 12px -10px rgba(38, 50, 56, 0.8);
    display: inline-flex;
    height: 34px;
    justify-content: center;
    line-height: 34px;
    min-width: 34px;
    padding: 0;
    width: 34px;
}

.provider-claim-add-card .tariff-card-actions .tariff-card-icon-action.btn-flat:hover {
    background-color: #f8fafb !important;
}

.provider-claim-add-card .tariff-card-actions .tariff-card-icon-action i,
.provider-claim-add-card .tariff-card-actions .tariff-mini-spin {
    color: #546e7a !important;
    font-size: 20px;
    line-height: 20px;
}

.provider-claim-add-card .tariff-card-actions .tariff-mini-spin {
    animation: tariff-spin 0.9s linear infinite;
    align-items: center;
    background-color: #ffffff !important;
    border: 1px solid rgba(84, 110, 122, 0.22);
    border-radius: 18px;
    box-shadow: 0 5px 12px -10px rgba(38, 50, 56, 0.8);
    display: inline-flex;
    height: 34px;
    justify-content: center;
    text-align: center;
    width: 34px;
}

.tariff-card-message {
    background: #fff8e1;
    border-radius: 6px;
    color: #6d4c41;
    margin: 8px 0 0;
    padding: 10px 12px;
}

.tariff-preview-overlay {
    background: rgba(38, 50, 56, 0.48);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1200;
}

.tariff-preview-modal {
    background: #fff;
    bottom: 32px;
    box-shadow: 0 18px 45px rgba(38, 50, 56, 0.24);
    display: flex;
    flex-direction: column;
    left: max(36px, calc((100vw - 1180px) / 2));
    position: fixed;
    right: max(36px, calc((100vw - 1180px) / 2));
    top: 104px;
    z-index: 1201;
}

.tariff-preview-content {
    flex: 1;
    overflow: hidden;
    padding: 32px 36px 20px;
}

.tariff-preview-search {
    margin-bottom: 22px;
    margin-top: 22px;
}

.tariff-preview-list {
    max-height: calc(100vh - 330px);
    overflow-y: auto;
}

.tariff-preview-close {
    background: #eceff1;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    height: 36px;
    position: absolute;
    right: 24px;
    top: 22px;
    width: 36px;
}

.tariff-preview-close i {
    color: #455a64;
    line-height: 36px;
}

.tariff-preview-footer {
    border-top: 1px solid #e0e0e0;
    padding-left: 36px;
    padding-right: 36px;
    text-align: right;
}

@media only screen and (max-width: 600px) {
    .tariff-preview-modal {
        bottom: 12px;
        left: 12px;
        right: 12px;
        top: 76px;
    }

    .tariff-preview-content {
        padding: 24px 18px 16px;
    }

    .tariff-preview-list {
        max-height: calc(100vh - 292px);
    }
}

@keyframes tariff-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
